import { createStore } from '@helpers/utils';

export const initialState = {
    scheme: [],
    status: [],
    dateStart: '',
    dateEnd: '',
    searchParam: '',
    limit: 10,
    sort: null,
    page: 1,
    total_page: 1,
    total_data: 0,
};

export const useFilters = createStore(initialState);
